import moment from "moment";

const exportCSV = (data, fileNamePrefix) => {
  if (!data || data.length === 0) {
    alert("No data to export!");
    return;
  }

  const headers = Object.keys(data[0]).join(",");
  const rows = data?.map((row) =>
    Object.values(row)
      .map((value) => `"${value}"`)
      .join(",")
  );

  const csvContent = [headers, ...rows].join("\n");
  const fileName = `${fileNamePrefix}_${moment().format("MM-DD-YYYY")}.csv`;

  const blob = new Blob([csvContent], { type: "text/csv" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const formatAddress = (address, city, state, zipCode) => {
  const parts = [address, city, state, zipCode].filter(Boolean);
    return parts.join(", ");
};

const calculateLoggedMinutes = (clockInTime, clockOutTime)  => {
    const inTime = new Date(clockInTime);
    const outTime = new Date(clockOutTime);

    const diffInMilliseconds = outTime - inTime;
    const diffInHours = diffInMilliseconds / (1000 * 60 * 60);

    return diffInHours?.toFixed(2);
  }

const getJobSchedule = (item) => {
  if (item?.multipleDayJob) {
    if (item?.jobScheduleEntitiesDto?.length > 0) {
      return item.jobScheduleEntitiesDto.map((itemm, index) => {
        const dateRange = `${moment(itemm?.startDate, "YYYY-MM-DD HH:mm:ss").format("MM/DD/YYYY")} - ${moment(itemm?.endDate, "YYYY-MM-DD HH:mm:ss").format("MM/DD/YYYY")}`;
        const days = [
          itemm?.sunday ? "Sun" : "",
          itemm?.monday ? "Mon" : "",
          itemm?.tuesday ? "Tue" : "",
          itemm?.wednesday ? "Wed" : "",
          itemm?.thursday ? "Thu" : "",
          itemm?.friday ? "Fri" : "",
          itemm?.saturday ? "Sat" : ""
        ].filter(Boolean).join(" ");
        const timeRange = `${moment.utc(itemm?.startTime, "YYYY-MM-DD HH:mm:ss").local().format("hh:mm A")} - ${moment.utc(itemm?.endTime, "YYYY-MM-DD HH:mm:ss").local().format("hh:mm A")}`;
        
        return `Schedule ${index + 1}: ${dateRange} on ${days}, ${timeRange} for ${itemm?.workHours} Hours`;
      }).join("\n");
    } else {
      return "No Schedule found";
    }
  } else {
    const date = moment.utc(item?.startTime, "YYYY-MM-DD HH:mm:ss").local().format("MM/DD/YYYY");
    const timeRange = `${moment.utc(item?.startTime, "YYYY-MM-DD HH:mm:ss").local().format("hh:mm A")} - ${moment.utc(item?.endTime, "YYYY-MM-DD HH:mm:ss").local().format("hh:mm A")}`;
    console.log("timeRange=======", timeRange)
    return `${date}\n${timeRange}`;
  }
};

// ---------------- CSV Export Functions ---------------- //

export const downloadTimeSheetCSV = (data = [], role_type = []) => {
  const formatAddress = (address, city, state, zip) =>
    [address, city, state, zip].filter(Boolean).join(", ");

  const showCompanyColumn =
    role_type?.includes("ROLE_OPENSTAFF_ADMIN") ||
    role_type?.includes("ROLE_OPENSTAFF_FINANCIAL_ADMIN");

  const formattedData = data?.map((item) => {
    const baseRow = {
      "Name": item?.applicantName || "-",
      "Worker Type": item?.workerType || "-",
      "Job Title": item?.jobTitle || "-",
    };

    // Conditionally add Company field in place
    if (showCompanyColumn) {
      baseRow["Company"] = item?.companyName || "-";
    }

    const restOfRow = {
      "Location": formatAddress(
        item?.address,
        item?.city,
        item?.state,
        item?.zipCode
      ),
      "Client Name": item?.customerName || "-",
      "Clock In Time": item?.clockInTime
        ? moment.utc(item?.clockInTime, "YYYY-MM-DD HH:mm:ss").local().format("MM-DD-YYYY HH:mm:ss")
        : "-",
      "Clock In Location":
        item?.clockInLocation?.latitude != null &&
        item?.clockInLocation?.longitude != null
          ? `${item?.clockInLocation.latitude}, ${item?.clockInLocation.longitude}`
          : "-",
      "Clock Out Time": item?.clockOutTime
        ? moment.utc(item?.clockOutTime, "YYYY-MM-DD HH:mm:ss").local().format("MM-DD-YYYY HH:mm:ss")
        : "-",
      "Clock Out Location":
        item?.clockOutLocation?.latitude != null &&
        item?.clockOutLocation?.longitude != null
          ? `${item?.clockOutLocation.latitude}, ${item?.clockOutLocation.longitude}`
          : "-",
      "Logged Hours":
        item?.clockInTime && item?.clockOutTime
          ? calculateLoggedMinutes(item?.clockInTime, item?.clockOutTime)
          : "-",
    };

    return { ...baseRow, ...restOfRow };
  });

  exportCSV(formattedData, "time_sheet_history");
};


export const downloadPaymentCSV = (data = [], role_type = "") => {
  const formattedData = data?.map((item) => {
    const base = {
      "Job Title": item?.jobTitle || "-",
      "Profession": item?.jobPosition || "-",
      "Created Date": item?.modifiedDate
        ? moment(item?.modifiedDate).format("MM/DD/YYYY")
        : "-",
      "Job Status": item?.jobStatus?.startsWith("e")
        ? item?.jobStatus.substring(1)
        : item?.jobStatus || "-",
      "Private": item?.isPrivateJob ? "Yes" : "No",
      "Location": formatAddress(
        item?.address,
        item?.city,
        item?.state,
        item?.zipCode
      ),
      "Client Name": item?.clientName || "-",
      "Job Type": item?.multipleDayJob ? "Multiple Day" : "Single Day",
      "Schedule": getJobSchedule(item),
      "Time Zone": item?.timeZoneId || "-",
      "Salary": `$${
        item?.salary
          ? ((item?.salary / 100) * item?.totalHours * item?.noOfHires).toFixed(
              2
            )
          : "0.00"
      }`,
      "Service Fee": `$${item?.serviceFee ? (item?.serviceFee / 100).toFixed(2) : "0.00"}`,
      "Booking Fee": `$${
        item?.bookingAndProcessingFee
          ? (item?.bookingAndProcessingFee / 100).toFixed(2)
          : "0.00"
      }`,
      "Total": `$${item?.amount ? (item?.amount / 100).toFixed(2) : "0.00"}`,
      "Actual Total": `$${item?.totalWorkedAmount ? (item?.totalWorkedAmount / 100).toFixed(2) : "0.00"}`,
      "Payment Method": item?.paymentMethod?.replace(/^"(.*)"$/, "$1") || "-",
      "Stripe Status": item?.captured ? item?.status : "uncaptured",
      "Payment ID": item?.paymentId || "-",
      "Payment Intent ID": item?.paymentIntentId || "-",
      "Transfer ID": item?.transferId || "-",
      "Worked Hours": item?.totalWorkedHours || 0,
      "Total Hours": item?.totalHours || 0,
    };

    if (role_type?.includes("ROLE_OPENSTAFF_ADMIN")) {
      base["Company"] = item?.name || "-";
    }

    return base;
  });

  exportCSV(formattedData, "payment_history");
};


export const downloadJobCSV = (data = [], role_type = "") => {
  const formattedData = data?.map((item) => {
    const base = {
      "Job Title": item?.jobTitle || "-",
      "Profession": item?.jobPosition || "-",
      "Created Date": item?.modifiedDate
        ? moment(item?.modifiedDate).format("MM/DD/YYYY")
        : "-",
      "Job Status": item?.jobStatus?.startsWith("e")
        ? item?.jobStatus.substring(1)
        : item?.jobStatus || "-",
      "Private": item?.isPrivateJob ? "Yes" : "No",
      "Location": formatAddress(
        item?.address,
        item?.city,
        item?.state,
        item?.zipCode
      ),
      "Client Name": item?.clientName || "-",
      "Job Type": item?.multipleDayJob ? "Multiple Day" : "Single Day",
      "Schedule": getJobSchedule(item),
      "Time Zone": item?.timeZoneId || "-",
      "Salary": `$${
        item?.salary
          ? ((item?.salary / 100) * item?.totalHours * item?.noOfHires).toFixed(
              2
            )
          : "0.00"
      }`,
      "Service Fee": `$${
        item?.serviceFee ? (item?.serviceFee / 100).toFixed(2) : "0.00"
      }`,
      "Booking Fee": `$${
        item?.bookingAndProcessingFee
          ? (item?.bookingAndProcessingFee / 100).toFixed(2)
          : "0.00"
      }`,
      "Total": `$${item?.amount ? (item?.amount / 100).toFixed(2) : "0.00"}`,
      "Workers": item?.applicantsName?.length > 0
                ? item?.applicantsName
                    .map(
                      (val) =>
                        `${val?.name}${val?.workerType && val?.workerType === 'Employee' ? ` (${val?.workerType})` : ''}`
                    )
                    .join(", ")
                : "-" ,
      "Worked Hours": item?.totalWorkedHours || 0,
      "Total Hours": item?.totalHours || 0,
    };

    if (role_type?.includes("ROLE_OPENSTAFF_ADMIN")) {
      base["Company"] = item?.name || "-";
    }

    return base;
  });

  exportCSV(formattedData, "job_history");
};


export const downloadJobHistoryCSV = (data = []) => {
  const ConvertInto_Hrs = (hrs) => {
    var num = hrs;
    var str = num.toString();
    var numarray = str.split(".");
    var a = new Array();
    a = numarray;
    let minuteVal = Number(a[1]) / 60;
    let strFnl = a[0] + minuteVal.toString().substring(1);
    return Number(strFnl).toFixed(2);
  };

  const formattedData = data?.map((item) => {
    // Format start and end dates separately
    const formattedStartDate = moment(item?.startTime, "YYYY-MM-DD HH:mm:ss")
      .local()
      .format("MM/DD/YYYY hh:mm A");
    const formattedEndDate = moment(item?.endTime, "YYYY-MM-DD HH:mm:ss")
      .local()
      .format("MM/DD/YYYY hh:mm A");

    // Handle multi-day job formatting
    const displayStartDate = item?.multipleDayJob
      ? `${moment(item?.startTime, "YYYY-MM-DD HH:mm:ss")
          .local()
          .format("MM/DD/YYYY")} ${item?.timeZoneId}`
      : `${formattedStartDate} ${item?.timeZoneId}`;

    const displayEndDate = item?.multipleDayJob
      ? `${moment(item?.endTime, "YYYY-MM-DD HH:mm:ss")
          .local()
          .format("MM/DD/YYYY")} ${item?.timeZoneId}`
      : `${formattedEndDate} ${item?.timeZoneId}`;

    return {
      "Job Title": item?.jobTitle,
      "Job Position": item?.jobPosition,
      "Start Date": displayStartDate,
      "End Date": displayEndDate,
      "Location": item?.locationName,
      "Client Name": item?.clientName ? item?.clientName : "",
      "Worker Name": `${item?.hireFirstName} ${item?.hireLastName}`,
      "Logged Hours": item?.totalWorkedHours
        ? ConvertInto_Hrs(item?.totalWorkedHours)
        : "0",
      "Total Hours": item?.totalHours
        ? item?.multipleDayJob
          ? item?.totalHours
          : ConvertInto_Hrs(item?.totalHours)
        : "0",
    };
  });

  exportCSV(formattedData, "job_history");
};
